export const EVENT_DATA = {
    CREDIT_SCORE: {
        eventCategory: "User_pre_approved",
        eventAction: "Finance",
        event: "custom_event"
    }
};
